import { Box, Button, CircularProgress, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../redux/actions/actions";
import { loadLiveCourses } from "../../redux/api_calls/apiCalls";
import IndividualVideoCard from "./IndividualVideoCard";

export default function VideoList() {
    const [visibleData, setVisibleData] = useState([])
    const { liveCoursesData, isLoading } = useSelector(state => state.liveCoursesState)
    const dispatch = useDispatch()

    useEffect(() => {
        if (liveCoursesData.length) {
            setVisibleData(liveCoursesData.slice(0, 4))
        }
    }, [liveCoursesData])

    useEffect(() => {
        dispatch(loadLiveCourses())
        // eslint-disable-next-line
    }, [])

    return (
        <Box
            width='100%'
            d='flex'
            flexDir='column'
            bg='white'
            border='1px solid rgba(0, 0, 0, 0.1)'
            borderRadius='10px'
            boxShadow='0px 4px 10px rgba(0, 0, 0, 0.1)'
            px='1rem'
            flex='1'
            justifyContent='space-between'
        >
            {
                isLoading ?
                    <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                        <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                    </Box> :
                    <Box width='100%' d='flex' flexDirection='column' justifyContent='flex-start'>
                        {
                            visibleData.length > 0 ?
                                visibleData.map((item, idx) => <IndividualVideoCard
                                    key={idx}
                                    id={idx}
                                    name={item.title}
                                    image={item.cover_image ? item.cover_image : null}
                                    date={formatDate(item.start.substring(0, 10)).substring(11)}
                                />) :
                                <Text
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    fontSize='16px'
                                    fontWeight='600'
                                    color='#222222'
                                    textAlign = 'center'
                                    mt = '2rem'
                                >
                                    {"No Data Available Yet!"}
                                </Text>
                        }
                    </Box>
            }
            <Box
                d='flex'
                width='100%'
                justifyContent='flex-start'
                py='1rem'
            >
                <Button
                    bg='#81b9ce'
                    padding='12px 91px 12px 90px'
                    fontSize='16px'
                    color='#FFFFFF'
                    fontWeight='800'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    my='1'
                >
                    View Analytics
                </Button>
            </Box>
        </Box>
    )
}